__turbopack_context__.v({
  "blockTitle": "_BlockTitleCS-module-scss-module__o32Ula__blockTitle",
  "blockTitleContainer": "_BlockTitleCS-module-scss-module__o32Ula__blockTitleContainer",
  "blockTitleContainerAboveTheFold": "_BlockTitleCS-module-scss-module__o32Ula__blockTitleContainerAboveTheFold",
  "blockTitleContainerVisible": "_BlockTitleCS-module-scss-module__o32Ula__blockTitleContainerVisible",
  "blockTitlePlaceholder": "_BlockTitleCS-module-scss-module__o32Ula__blockTitlePlaceholder",
  "blocksBackgroundColor": "_BlockTitleCS-module-scss-module__o32Ula__blocksBackgroundColor",
  "blocksFontColor": "_BlockTitleCS-module-scss-module__o32Ula__blocksFontColor",
  "editButton": "_BlockTitleCS-module-scss-module__o32Ula__editButton",
  "editButtonDisabled": "_BlockTitleCS-module-scss-module__o32Ula__editButtonDisabled",
  "editPencil": "_BlockTitleCS-module-scss-module__o32Ula__editPencil",
  "editPencilDisabled": "_BlockTitleCS-module-scss-module__o32Ula__editPencilDisabled",
  "editableTitle": "_BlockTitleCS-module-scss-module__o32Ula__editableTitle",
  "secondaryNavBackgroundColor": "_BlockTitleCS-module-scss-module__o32Ula__secondaryNavBackgroundColor",
  "themeBackgroundColor": "_BlockTitleCS-module-scss-module__o32Ula__themeBackgroundColor",
  "themeFontColor": "_BlockTitleCS-module-scss-module__o32Ula__themeFontColor",
  "themeFontFamily": "_BlockTitleCS-module-scss-module__o32Ula__themeFontFamily",
  "title": "_BlockTitleCS-module-scss-module__o32Ula__title",
  "titleContainer": "_BlockTitleCS-module-scss-module__o32Ula__titleContainer",
  "titleContainerHasRightElement": "_BlockTitleCS-module-scss-module__o32Ula__titleContainerHasRightElement",
  "titleTransitionContainer": "_BlockTitleCS-module-scss-module__o32Ula__titleTransitionContainer",
  "titleWrapper": "_BlockTitleCS-module-scss-module__o32Ula__titleWrapper",
  "transitionEnter": "_BlockTitleCS-module-scss-module__o32Ula__transitionEnter",
  "transitionEnterActive": "_BlockTitleCS-module-scss-module__o32Ula__transitionEnterActive",
  "transitionEnterDone": "_BlockTitleCS-module-scss-module__o32Ula__transitionEnterDone",
  "transitionExit": "_BlockTitleCS-module-scss-module__o32Ula__transitionExit",
  "transitionExitActive": "_BlockTitleCS-module-scss-module__o32Ula__transitionExitActive",
  "transitionExitDone": "_BlockTitleCS-module-scss-module__o32Ula__transitionExitDone",
  "viewMoreButton": "_BlockTitleCS-module-scss-module__o32Ula__viewMoreButton",
  "viewMoreButtonContainer": "_BlockTitleCS-module-scss-module__o32Ula__viewMoreButtonContainer",
});
